import { render, staticRenderFns } from "./SetHostReserveResource.vue?vue&type=template&id=3946e5c0&"
import script from "./SetHostReserveResource.vue?vue&type=script&lang=js&"
export * from "./SetHostReserveResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports